import { render, staticRenderFns } from "./PhotoIcon.vue?vue&type=template&id=1a389766&scoped=true&"
import script from "./PhotoIcon.vue?vue&type=script&lang=js&"
export * from "./PhotoIcon.vue?vue&type=script&lang=js&"
import style0 from "./PhotoIcon.vue?vue&type=style&index=0&id=1a389766&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a389766",
  null
  
)

export default component.exports